// extracted by mini-css-extract-plugin
export var container = "course-movies-list-module--container--oD1-o";
export var emptyInfo = "course-movies-list-module--empty-info--ZZfNS";
export var item = "course-movies-list-module--item--LwA2U";
export var labelName = "course-movies-list-module--label-name--UJeR1";
export var movieCounter = "course-movies-list-module--movie-counter--rZI+r";
export var playlist = "course-movies-list-module--playlist--s7TfH";
export var topWrapper = "course-movies-list-module--top-wrapper--bYgns";
export var trainingTypeWrapper = "course-movies-list-module--training-type-wrapper--Jg-Zw";
export var wrapper = "course-movies-list-module--wrapper--ZSHdY";